<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <v-card class="coming-soon-modal">
      <v-card-title>
        <h2 class="font card-title">¡Importante!</h2>
      </v-card-title>
      <v-card-text class="font card-text">
        Vas a eliminar a {{ item.name }} de tu organización.<br>¿Deseas eliminarlo?
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="onCancel()">Cancelar</v-btn>
        <v-btn color="primary" text @click="onRemove()">Eliminar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import { DISCONNECT_USER_FROM_ORGANIZATION_MUTATION, DISCONNECT_ORGANIZATION_FROM_USER_MUTATION } from '../../constants/graphql';
  export default {
    data () {
      return {
      };
    },
    props: {
      dialog: {
        type: Boolean,
        default: false
      },
      item: {
        type: Object,
        default: {}
      },
      organizationId: {
        type: Number,
        default: 0
      }
    },
    computed: {
    },
    watch: {
      dialog (val) {
        this.$emit('update:dialog', !!val);
      }
    },
    methods: {
      onCancel () {
        this.$emit('update:dialog', false);
      },
      onRemove () {
        this.$apollo.mutate({
          mutation: DISCONNECT_USER_FROM_ORGANIZATION_MUTATION,
          variables: {
            userId: this.item.id,
            orgId: this.organizationId
          }
        }).then(() => {
          this.$apollo.mutate({
            mutation: DISCONNECT_ORGANIZATION_FROM_USER_MUTATION,
            variables: {
              userId: this.item.id,
              orgId: this.organizationId
            }
          }).then(() => {
          }).catch(() => {
          });
        }).catch(() => {
        });
        this.$emit('update:dialog', false);
      }
    }
  };
</script>


// WEBPACK FOOTER //
// RemoveUserModal.vue?4ea0f9b4